import type { LucideIcon } from "lucide-react";
import { Inbox, UserRound } from "lucide-react";

export type TrustSuiteTab = "concerns" | "residents";

export type TrustSuiteTabConfig = {
  id: TrustSuiteTab;
  label: string;
  icon: LucideIcon;
};

export const TRUST_SUITE_TABS: TrustSuiteTabConfig[] = [
  { id: "concerns", label: "Concerns", icon: Inbox },
  { id: "residents", label: "Residents", icon: UserRound },
];
